import { Modal } from "@mantine/core";
import "./FilingStatusModal.scss";
import {
  IconBabyCarriage,
  IconCirclesRelation,
  IconUser,
  IconUserCircle,
  IconUsersMinus,
} from "@tabler/icons-react";

interface FilingStatusModalProps {
  readonly opened: boolean;
  readonly setOpened: (value: boolean) => void;
}

export function FilingStatusModal({
  opened,
  setOpened,
}: FilingStatusModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title={<h2>What's my filing status?</h2>}
      size={645}
      className="filing-status-modal"
    >
      <div className="filing-status-modal-content">
        {/* Description text at the top */}
        <p>
          Your filing status determines the tax brackets you fall into and the
          deductions and credits you can claim. It depends on your marital
          status and whether you have any dependents.
        </p>

        <h2 className="filing-status-title">Filing Status</h2>

        {/* Filing Status Options */}
        <div className="filing-status-options">
          {[
            {
              title: "Single",
              description:
                "If you're unmarried or divorced and don't qualify for other statuses.",
              icon: <IconUser size={40} />,
            },
            {
              title: "Married Filing Jointly",
              description:
                "If you're married and file together with your spouse. You share responsibility for taxes.",
              icon: <IconCirclesRelation size={40} />,
            },
            {
              title: "Married Filing Separately",
              description:
                "If you're married but choose to file separately from your spouse. You're only responsible for your own taxes.",
              icon: <IconUsersMinus size={40} />,
            },
            {
              title: "Head of Household (HOH)",
              description:
                "If you're unmarried, support a home, and have a qualifying dependent living with you most of the year.",
              icon: <IconBabyCarriage size={40} />,
            },
            {
              title: "Qualifying Surviving Spouse",
              description:
                "If you're widowed within 2 years, have a dependent child, and haven't remarried.",
              icon: <IconUserCircle size={40} />,
            },
          ].map(({ title, description, icon }) => (
            <div key={title} className="filing-status-option">
              <div className="icon-container">
                <span className="status-icon">{icon}</span>
              </div>
              <div className="status-content">
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
